import { z } from 'zod';
/**
 * `media_tagger` (spec 80 §4.7, spec 30 §4.6, S80-2): AI suggestions for an
 * uploaded photo or video poster. The run's `params` carry only the asset ID;
 * the context builder adds the metadata-free preview variant as image input,
 * the property's active pillar keys and names, apartment IDs and names and the
 * asset's existing tags — never the original, its file name, EXIF data or the
 * uploader (REQ-80-008, REQ-KI-012).
 */
export const MEDIA_TAGGER_LIMITS = {
    maxTags: 15,
    maxTagLength: 40,
    maxDescriptionLength: 500,
    /** Entries a context lists and a run may suggest (prompt v5 on, E470). */
    maxContextEntries: 60,
    maxEntrySuggestions: 5,
};
/** The entry kinds the tagger may suggest (spec 30 section 4.21): things a photo can show; never people. */
export const MEDIA_TAGGER_ENTRY_KINDS = ['apartment', 'place', 'product'];
/** Mirror the PostgreSQL enums `media_season` and `media_quality` (migration 0013). */
export const MEDIA_TAGGER_SEASONS = ['spring', 'summer', 'autumn', 'winter', 'all_year'];
export const MEDIA_TAGGER_QUALITIES = ['low', 'medium', 'high'];
export const mediaTaggerInputSchema = z.object({
    asset_id: z.uuid(),
});
export const mediaTaggerOutputSchema = z.object({
    tags: z.array(z.string().min(1).max(MEDIA_TAGGER_LIMITS.maxTagLength)).max(MEDIA_TAGGER_LIMITS.maxTags),
    description: z.string().min(1).max(MEDIA_TAGGER_LIMITS.maxDescriptionLength),
    /** `null` when the context lists no `seasons` (prompt v3, a profile without seasons, S30-G8); v1/v2 always return one. */
    season: z.enum(MEDIA_TAGGER_SEASONS).nullable(),
    /** A key from the context's `pillars`, or `null` when none fits. */
    pillar_key: z.string().min(1).max(100).nullable(),
    quality: z.enum(MEDIA_TAGGER_QUALITIES),
    /**
     * Entries the photo clearly shows (prompt v5 on, E470), each an ID from the context's `entries`; stored as
     * suggestions a human decides. A default, not optional: the provider schema needs every property.
     */
    entry_ids: z.array(z.string()).max(MEDIA_TAGGER_LIMITS.maxEntrySuggestions).default([]),
});
//# sourceMappingURL=media-tagger.js.map